import { Master } from '@/domain/entities/Master'
import { AxiosResponse } from 'axios'
import { BaseResponseMapper } from './Base'

export class MasterDataMapper extends BaseResponseMapper {
  public convertMasterFromApi(result: AxiosResponse<any>): Master {
    const { data } = result
    return new Master(data.success, data.message, data.data)
  }
}
